import { use } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import resources from '../localization/resources';

// eslint-disable-next-line react-hooks/rules-of-hooks
use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'mi', 'sm', 'hi', 'zh'],
    resources,
    ns: ['common'],
    defaultNS: 'common',
    returnEmptyString: true,
  });
